import { render } from "./TimeDistribution.vue?vue&type=template&id=037289ac"
import script from "./TimeDistribution.vue?vue&type=script&lang=js"
export * from "./TimeDistribution.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__